module.exports = __webpack_public_path__ + "media/SMID-intro1.c41a2823.mp4";